export const US_STATES = {
  AL: "Alabama", AK: "Alaska", AZ: "Arizona", AR: "Arkansas", CA: "California",
  CO: "Colorado", CT: "Connecticut", DE: "Delaware", DC: "District of Columbia",
  FL: "Florida", GA: "Georgia", HI: "Hawaii", ID: "Idaho", IL: "Illinois",
  IN: "Indiana", IA: "Iowa", KS: "Kansas", KY: "Kentucky", LA: "Louisiana",
  ME: "Maine", MD: "Maryland", MA: "Massachusetts", MI: "Michigan", MN: "Minnesota",
  MS: "Mississippi", MO: "Missouri", MT: "Montana", NE: "Nebraska", NV: "Nevada",
  NH: "New Hampshire", NJ: "New Jersey", NM: "New Mexico", NY: "New York",
  NC: "North Carolina", ND: "North Dakota", OH: "Ohio", OK: "Oklahoma",
  OR: "Oregon", PA: "Pennsylvania", RI: "Rhode Island", SC: "South Carolina",
  SD: "South Dakota", TN: "Tennessee", TX: "Texas", UT: "Utah", VT: "Vermont",
  VA: "Virginia", WA: "Washington", WV: "West Virginia", WI: "Wisconsin", WY: "Wyoming",
} as const;

export type UsState = keyof typeof US_STATES;
export type StateSource = "detected" | "selected" | "unknown";
export const EMAIL_CAPTURE_SURFACE = "email_popup_v2";
export const EMAIL_CAPTURE_DELAY_MS = 10_000;
export const EMAIL_CAPTURE_PHONE_HOME_DELAY_MS = 3_000;
export const EMAIL_CAPTURE_DISMISSED = "upsider_email_popup_dismissed";
export const EMAIL_CAPTURED = "upsider_email_captured";
export const EMAIL_CAPTURE_SESSION = "upsider_email_popup_shown";
export const EMAIL_CAPTURED_EVENT = "upsider:email-captured";

export function normalizeUsState(value: unknown): UsState | null {
  if (typeof value !== "string") return null;
  const code = value.trim().toUpperCase();
  return Object.hasOwn(US_STATES, code) ? code as UsState : null;
}

export function detectUsState(headers: { get(name: string): string | null }): UsState | null {
  return headers.get("x-vercel-ip-country") === "US"
    ? normalizeUsState(headers.get("x-vercel-ip-country-region"))
    : null;
}

export function emailCaptureCta(state: UsState | null): string {
  return state ? `Send me the best bets in ${state}` : "Send me the best bets";
}

export function isEmailCaptureRoute(pathname: string | null): boolean {
  if (!pathname) return false;
  return pathname === "/" || pathname === "/learning-center/ads/charlie-pick6" || ["/tools", "/calculators", "/videos"].some(
    (route) => pathname === route || pathname.startsWith(`${route}/`),
  );
}
